import type { MapboxSuggestion } from '../components/AddressSuggestField/types';

type Params = {
  country: string;
  sessionToken: string;
  type: 'street' | 'address' | string;
};

const API_KEY = process.env.NEXT_PUBLIC_MAP_BOX_API_KEY ?? 'NO_KEY';

export async function fetchMapboxSuggestions(
  search: string,
  { sessionToken, country, type }: Params,
) {
  const queryParams = new URLSearchParams();
  queryParams.set('q', search);
  queryParams.set('access_token', API_KEY);
  queryParams.set('session_token', sessionToken);
  queryParams.set('language', 'de');
  queryParams.set('country', country);
  queryParams.set('types', type);
  queryParams.set('limit', '6');

  const response = await fetch(`https://api.mapbox.com/search/searchbox/v1/suggest?${queryParams}`);

  if (!response.ok) {
    throw response;
  }

  const { suggestions } = await response.json();

  return suggestions as MapboxSuggestion[];
}
